import { useEffect } from 'react';
import { useStore } from '@/app/StoreContext';

export function useFirstVisitOnboarding() {
  const { onboarding } = useStore();
  useEffect(() => {
    onboarding.openIfFirstVisit();
  }, [onboarding]);
}
